let prefix = '/api/entrance/tickets';
import _ from "lodash";

function index() {
    return window.axios.get(prefix + '/index');
}
function indexTicketsWithFilter(data) {
    return window.axios.get(prefix + '/ticketfilter?from=' + data.dates.from + '&to=' + data.dates.to + '&completed=' + data.completed + '&requestUser=' + data.requestUser);
}
function storeTicket(data) {

    let formData = new FormData();
    formData.append('supplier_name', data.supplier_name);
    formData.append('company_name', data.company_name);
    formData.append('card_code', data.card_code ? data.card_code : '');
    formData.append('sap_provider', data.sap_provider ? 1 : 0);
    formData.append('date_out', data.date_out);

    _.forEach(data.items, (item, index) => {
        formData.append(`items[${index}][itemName]`, item.itemName);
        formData.append(`items[${index}][extraData]`, item.extraData ? item.extraData : '' );
        formData.append(`items[${index}][quantity]`, item.quantity);
        formData.append(`items[${index}][takeItem]`, item.takeItem ? 1 : 0 );
        formData.append(`items[${index}][in_plant]`, item.in_plant ? 1 : 0 );
    });

    _.forEach(data.evidences, (file) => {
            formData.append("documents[]", file);
        });

    return window.axios.post(prefix + '/store', formData, {
        "Content-Type": "multipart/form-data",
    });
}
function completeTicket(data) {
    return window.axios.patch(prefix + '/complete/' + data.id);
}
function takeItemOut(data) {
    return window.axios.patch(prefix + '/takeoutitem/' + data.id);
}
export default {
    index, storeTicket, completeTicket, takeItemOut, indexTicketsWithFilter

}